import { FontEntry } from '../../types/font'

export const robotoFlexTtt: FontEntry = {
  displayName: 'roboto-flex-ttt',
  weights: {},
  variables: {
    normal: {
      file: 'RobotoFlexTTT',
      extension: 'woff2',
      format: 'woff2',
      weightRange: [100, 1000]
    },
    italic: {
      file: 'RobotoSerif-Italic',
      extension: 'woff2',
      format: 'woff2',
      weightRange: [100, 1000]
    }
  },
  fallbackMetrics: {
    arial: {
      regular: {
        sizeAdjust: 99.04,
        ascentOverride: 93.67,
        descentOverride: 24.65,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 97.94,
        ascentOverride: 94.72,
        descentOverride: 24.93,
        lineGapOverride: 0
      }
    },
    roboto: {
      regular: {
        sizeAdjust: 100.49,
        ascentOverride: 92.32,
        descentOverride: 24.29,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 103.76,
        ascentOverride: 89.41,
        descentOverride: 23.53,
        lineGapOverride: 0
      }
    }
  }
}
